import { FC } from 'react';

import VideoModal from 'src/components/common/modal/videoModal';

const BidsRevisionModal: FC = () => (
    <VideoModal videoUrl="https://www.youtube.com/watch?v=51Cagd1DrQY&ab_channel=apadua" />
);

export default BidsRevisionModal;
